import React, { useEffect, useState, useMemo } from 'react';
import { Modal, Form, Input, Select, Button, message, Row, Col } from 'antd';
import { useDispatch } from 'react-redux';
import { payReferralAction, payReferrerAction, sendEmailToTheReferrerAction } from '../../actions/refer';
import { getAllRewards } from '../../actions/business';
import { useSelector } from 'react-redux';
import { calculateCommission, capitalizeFirstLetter, getRewardType } from '@utils/comman';

const PaymentModal = ({ visible, setVisible, isReferral = false, userData, refetchData }: any) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const rewardList = useSelector((state: any) => state?.Business?.rewardList?.data);
  const { isLoading } = useSelector((state: any) => state?.General);

  const [amount, setAmount] = useState<any>();
  const [rewardType, setRewardType] = useState<string>();
  const [totalAmount, setTotalAmount] = useState<number>();
  const [rewardId, setRewardId] = useState<number>();
  // const [description, setDescription] = useState<string>(''); // Initialize description state

  useEffect(() => {
    dispatch(getAllRewards({}, () => {}));
  }, []);

  useEffect(()=> {
    let rewardType = rewardList?.find((item:any)=> item?.rewardName === visible?.data?.referrerRewards?.[0]?.offerName )
    if (!isReferral) {
      form.setFieldsValue({
        amount: +visible?.data?.referralsAmount,
        referralCount: +visible?.data?.outstanding,
        reward: visible?.data?.referrerRewards?.[0]?.offerName,
        rewardType: getRewardType(+rewardType?.referrerRewardValue, rewardType?.referrerRewardType) ,
      });
    } else {
      // Set default outcome to successful for referral payments
      form.setFieldsValue({
        outcome: 'successful'
      });
    }
  }, [visible, amount])

  const updatedRewardList = useMemo(() => {
    let list = rewardList; // !isReferral ? rewardList : visible?.data?.rewards;
    return list?.map((item: any) => {
      if (item?.referrerRewardValue) {
      //   return {
      //     ...item,
      //     label: item?.rewardName, //!isReferral ? item?.rewardName : item?.offerName,
      //     value: item?.id //!isReferral ? item?.referrerRewardValue : item?.offerValue,
      //   }
      // } else if(!isReferral) {
        return {
          ...item,
          label: item?.rewardName, //!isReferral ? item?.rewardName : item?.offerName,
          value: item?.id //!isReferral ? item?.referrerRewardValue : item?.offerValue,
        }
       } else return
    });
    
  }, [visible]); // Use `useMemo` to optimize updatedRewardList calculation

  const getOutcome = (value: string) => {
    switch (value) {
      case 'successful':
        return true;
      case 'un-successful':
        return false;
      case 'pending':
        return false;
      default:
        return false;
    }
  };

  const handleOk = () => {
    form.validateFields().then((values) => {
      // if business and paying for referral
      if (userData?.data?.roleId === 2 && isReferral) {
        // Submit the form data to your API or perform any other action
        let payload = {
          referralId: visible?.data?.id,
          paidOffer: amount,
          outcome: getOutcome(values?.outcome),
          totalAmountPaid: totalAmount,
          // offerType: rewardType,
          offerId: values?.reward,

          // description: values?.description, // Use the updated description state
        };
        if (rewardType === 'percentage') {
          if (!amount) {
            message.error('Paid offer cannot be empty!');
            return; // Exit if amount is empty
          } else {
            // Proceed to dispatch the action if amount is not empty
            dispatch(
              payReferralAction(payload, (resp: any) => {
                if (resp) {
                  // Send email after successful payment only if outcome is successful
                  if (getOutcome(values?.outcome) === true) {
                    const emailPayload = {
                      referralId: visible?.data?.id,
                      outcome: true
                    };
                    dispatch(sendEmailToTheReferrerAction(emailPayload, (emailRes: any) => {
                      // if (emailRes?.status === 200 || emailRes?.status === 201) {
                      //   message.success('Payment completed and email sent successfully!');
                      // } else {
                      //   message.warning('Payment completed but email sending failed.');
                      // }
                    }));
                  } else {
                    message.success('Payment completed successfully!');
                  }
                  
                  setVisible({ ...visible, show: false });
                  refetchData();
                }
              })
            );
          }
        } else if (rewardType !== 'percentage') {
          dispatch(
            payReferralAction(payload, (resp: any) => {
              if (resp) {
                // Send email after successful payment only if outcome is successful
                if (getOutcome(values?.outcome) === true) {
                  const emailPayload = {
                    referralId: visible?.data?.id,
                    outcome: true
                  };
                  dispatch(sendEmailToTheReferrerAction(emailPayload, (emailRes: any) => {
                    // if (emailRes?.status === 200 || emailRes?.status === 201) {
                    //   message.success('Payment completed and email sent successfully!');
                    // } else {
                    //   message.warning('Payment completed but email sending failed.');
                    // }
                  }));
                } else {
                  message.success('Payment completed successfully!');
                }
                
                setVisible({ ...visible, show: false });
                refetchData();
              }
            })
          );
        }
      } else if (!isReferral) {
        let payload = {
          referrerCode: visible?.data?.businessCode,
          referralsCount: +visible?.data?.referralsCount || +values?.referralCount,
          amount: +values?.amount,
          // description: values?.description, // Use the updated description state
        };
        if (!values?.amount) {
          message.error('Amount cannot be empty!');
          return; // Exit if amount is empty
        } else {
          console.log("payload ::::::::",payload)
          dispatch(
            payReferrerAction(payload, (resp: any) => {
              if (resp) {
                setVisible({ ...visible, show: false });
                refetchData()
              }
            })
          );
        }
      } else {
        console.error('Please fill in all fields');
      }

    }).catch((error) => {
      console.error('Error submitting form:', error);
    });
  };

  const handleCancel = () => {
    console.log("cancel")
    setVisible(false);
    // form.setFieldsValue({
    //   amount: "",
    //   reward: "",
    //   offerType: "",
    //   totalAmount: '',
    //   paidOffer: ''
    // });
  };

  const handleRewardChange = (value: any) => {
    let rewardValue = rewardList?.find((item: any) => item?.id === value);
    console.log("Reward change ::::::", rewardValue)
    setRewardType(rewardValue?.referrerRewardType)
    setRewardId(value)
    let referrerAmount = +visible?.data?.invite?.referralsAmount;
  
    if(!isReferral) {
      console.log('referrer')
      let payableAmount =
      rewardValue?.referrerRewardType === 'percentage'
      ? calculateCommission(referrerAmount, +rewardValue?.referrerRewardValue)
      : +rewardValue?.referrerRewardValue ? +rewardValue?.referrerRewardValue : 0;
      setAmount(payableAmount ? payableAmount.toFixed(2) : '');
      console.log('payableAmount ::::::::', rewardValue?.referrerRewardValue, payableAmount)
      form.setFieldsValue({
        rewardType: getRewardType(+rewardValue?.referrerRewardValue, rewardValue?.referrerRewardType),
        amount: payableAmount ? payableAmount.toFixed(2) : '',
      });
    }

    if(isReferral) {
      console.log('referral',rewardType)
      // let referralAmount = 
      if (rewardValue) {
        let payableAmount =
        rewardValue?.referrerRewardType === 'percentage'
        ? calculateCommission(totalAmount, +rewardValue?.referrerRewardValue)
        : +rewardValue?.referrerRewardValue ? +rewardValue?.referrerRewardValue : 0;
        setAmount(payableAmount ? payableAmount.toFixed(2) : '');
        console.log("payableAmount :::::::;", payableAmount)
        form.setFieldsValue({
          rewardType: getRewardType(rewardValue?.referrerRewardValue, rewardValue?.referrerRewardType),
          paidOffer: payableAmount ? payableAmount.toFixed(2) : "",
          // amount: rewardValue?.referralRewardValue,
        });
      }
    } else {
      console.error('Invalid rewardValue or referralRewardType');
    }
  };

  const handleChangeTotalAmount =(value:any)=> {
    let rewardValue = rewardList?.find((item: any) => item?.id === rewardId);
    console.log("Total amount", rewardType, rewardValue)
    let amountValue = +value;
    let payableAmount =
    rewardValue?.referrerRewardType === 'percentage'
    ? calculateCommission(amountValue, +rewardValue?.referrerRewardValue)
    : rewardValue?.referrerRewardValue ? +rewardValue?.referrerRewardValue : 0;
    setTotalAmount(value);
    setAmount(amountValue ? payableAmount.toFixed(2) : '');
    console.log("amountValue :::", amountValue, payableAmount)
    payableAmount && form.setFieldsValue({
      paidOffer: amountValue ? payableAmount.toFixed(2) : '',
    });
    // setDescription(payableAmount ? `Payment for referral is $ ${payableAmount.toFixed(2)} based on reward` : '');
  }


  // ********** Not needed for now ************** //
  // const renderDescription = () => useMemo(() => {
  //   return (
  //     <Form.Item
  //       label="Description"
  //       name="description"
  //     >
  //       <Input.TextArea
  //         rows={4} defaultValue={description} placeholder="Enter description" />
  //     </Form.Item>
  //   )
  // }, [amount, description])

  const RenderFormInput = () => {
    if (!isReferral) {
      return (
        <>
        <Form.Item
          label="Outstanding Referral Count"
          name="referralCount"
        >
          <Input disabled defaultValue={visible?.data?.invite?.outstanding} size='large' type="number" placeholder="Enter referral count" />
        </Form.Item>
        <Row>
            <Col lg={12}>
              <Form.Item
                label="Reward Name"
                name="reward"
                rules={[{ required: false, message: 'Please select reward' }]}
              >
                <Select disabled={!isReferral} placeholder="Select reward" onChange={(value: any) => handleRewardChange(value)}>
                <Select.Option disabled={!isReferral} value={""}> No Reward </Select.Option>
                {updatedRewardList?.map((item: any, index: number) => {
                  if(item?.label) {
                    return (
                      <Select.Option  value={item?.value} key={index}>{item?.label} </Select.Option>
                    );
                  }
                })}
                </Select>
              </Form.Item>
            </Col>
            {(rewardType || !isReferral) && <Col lg={11} style={{ marginLeft: '15px' }}>
              <Form.Item
                label="Reward Type"
                name="rewardType"
              >
                <Input disabled={!isReferral} size='large' style={{ height: '48px' }} value={getRewardType(amount, rewardType)} placeholder="Reward Type" />
              </Form.Item>
            </Col>}

          </Row>
        <Form.Item
          label="Total Amount"
          name="amount"
        >
          <Input defaultValue={visible?.data?.invite?.referralsAmount} size='large' type="number" placeholder="Enter total amount" />
        </Form.Item>
        
          {/* {renderDescription()}
          <span style={{ color: '#8f8a8a'}}>
            <i>{description}</i>
          </span> */}
      </>
      );
    } else {
      return (
        <>
          <Form.Item
            label="Outcome"
            name="outcome"
            rules={[{ required: true, message: 'Please select outcome' }]}
          >
            <Select disabled defaultValue="successful" placeholder="Select outcome">
              <Select.Option value="successful">Successful</Select.Option>
              <Select.Option value="un-successful">Un-Successful</Select.Option>
            </Select>
          </Form.Item>
          <Row>
            <Col lg={12}>
              <Form.Item
                label="Reward Name"
                name="reward"
                rules={[{ required: false, message: 'Please select reward' }]}
              >
                <Select placeholder="Select reward" onChange={(value: any) => handleRewardChange(value)}>
                <Select.Option value={""}> No Reward </Select.Option>
                {updatedRewardList?.map((item: any, index: number) => {
                  if(item?.label) {
                    return (
                      <Select.Option value={item?.value} key={index}>{item?.label} </Select.Option>
                    );
                  }
                })}
                </Select>
              </Form.Item>
            </Col>
            {rewardType && <Col lg={11} style={{ marginLeft: '15px' }}>
              <Form.Item
                label="Reward Type"
                name="rewardType"
              >
                <Input size='large' style={{ height: '48px' }} value={getRewardType(amount, rewardType)} placeholder="Reward Type" />
              </Form.Item>
            </Col>}
          </Row>
          <Form.Item
            label="Total Amount You Received"
            name="amount"
          >
            <Input onChange={(evt:any) => handleChangeTotalAmount(evt?.target?.value)} defaultValue={totalAmount} size='large' type="number" placeholder="Enter total amount" />
          </Form.Item>
          <Form.Item
            label="Paid Offer To The Referral"
            name="paidOffer"
            rules={[
              {
                required: false,
                message: 'Please enter paid offer'
              },
            ]}
          >
            <Input size='large' value={amount ? amount : ""} onChange={(evt:any)=> setAmount(evt?.target?.value)} placeholder="Enter paid offer" />
          </Form.Item>
            {/* {renderDescription()} */}
            {/* <span style={{ color: '#8f8a8a'}}>
              <i>{description}</i>
            </span> */}
        </>
      );
    }
  };

  return (
    <div>
      <Modal
        title="Make a Payment"
        visible={visible?.show}
        closable={false}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <div className="col-lg-12 mt-15">
            <div className="text-end btn-groups-Forms">
              <button
                className="btn btn-outline-primary"
                onClick={() => {
                  console.log("cancel f")
                  setVisible({ ...visible, show: false });
                  form.setFieldsValue({
                    amount: "",
                    reward: "",
                    rewardType: "",
                    totalAmount: '',
                    paidOffer: '',
                    referralCount: ""
                  });
                }}
              >
                Cancel
              </button>
              <Button
                className="btn btn-primary"
                type="primary"
                onClick={() => form.submit()}
                loading={isLoading}
              >
                {isLoading ? 'Loading...' : 'Pay'}
              </Button>
            </div>
          </div>
        ]}
      >
        <Form form={form} onFinish={handleOk} layout="vertical">
          {RenderFormInput()}
        </Form>
      </Modal>
    </div>
  );
};

export default PaymentModal;